export const featureFlags = {
	betaLoginPage: process.env.REACT_APP_LOGIN_PAGE_BETA === "true",
	quotePage: process.env.REACT_APP_QUOTE_PAGE === "true",
};
